import LOGO from '@/assets/images/auth/Logo-nexgenBros.png';
import IMAGECHART from '@/assets/svg/auth/image-chart-login.svg';
import CountUp from 'react-countup';

export default function AuthBackground() {
  const number = [
    {
      id: 1,
      number: 20,
      icon: '+',
      title: 'Online Stores',
    },
    {
      id: 2,
      number: 96,
      icon: '%',
      title: 'Happy Customers',
    },
    {
      id: 3,
      number: 10,
      icon: 'K+',
      title: 'Orders',
    },
    {
      id: 4,
      number: 5,
      icon: 'K+',
      title: 'Items',
    },
  ];
  return (
    <div className="pt-[4.8rem] pl-[5.6rem] pr-[8rem]">
      <img src={LOGO} alt="LOGO-NexgenBross" className="w-[22.2rem] h-[4.3rem]" />

      <h1 className="text-white text-[4.8rem] font-semibold mt-[5rem] mb-[2.5rem]">
        Your customer's world,
        <br /> synchronized on <br /> your screen
      </h1>

      <p className="sub-text-login text-[1.8rem] font-medium mt-[2.5rem] mb-[2.5rem]">
        Connect your e-commerce platforms and streamline <br /> your fulfillment process with our
        powerful CRM solution
      </p>

      <div className="pl-[1.4rem] mt-[2.5rem] mb-[2.5rem]">
        <img src={IMAGECHART} alt="LOGO-NexgenBross" className="w-full h-full" />
      </div>

      <div className="grid grid-cols-4 grid-flow-col mt-[2.5rem] mb-[5rem] gap-[4.7rem]">
        {number.map((item) => (
          <div key={item.id} className="flex flex-col">
            <div>
              <CountUp
                start={0}
                end={item.number}
                duration={2}
                className="text-white text-[3rem] font-bold"
              />
              <span className="text-white text-[3rem] font-bold">{item.icon}</span>
            </div>
            <div>
              <p className="sub-text-login text-[1.6rem] font-medium">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
